import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 100%;
    height: 281px;
    background: lightgrey;

    ${(props) => (props.background ? {
    'background': 'url(' + props.background + ')',
    'background-size': 'cover'
} : '')}
`;